import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { breadcrumbAction, tabNavigationAction } from '../../_actions';
import QuestionnairesGrid from './QuestionnaireGrid/QuestionnairesGrid';
import { getQuestionnaireGridNavigationItem } from './QuestionnaireGrid/utils';

const Questionnaire = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    useEffect(() => {
        const SurveyQuestionTemplateNavigation = getQuestionnaireGridNavigationItem(t)
        dispatch(tabNavigationAction.setNavigationTab(SurveyQuestionTemplateNavigation.tabs))
        dispatch(breadcrumbAction.setBreadcrumbItem(SurveyQuestionTemplateNavigation.breadCrumbs))
    }, [dispatch, t])

    return (
        <>
            <QuestionnairesGrid />
        </>
    )

}

export default Questionnaire
